import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';

import Checkbox from '@/components/common/Checkbox';
import FormError from '../FormError';

const CheckboxField = ({ id, name, isRequired, ...rest }) => {
  const { register, formState: { errors } } = useFormContext();

  return (
    <>
      <Checkbox id={id} data-rbf={`input${id ? '-' + id : ''}`} isRequired={isRequired} {...register(name, { required: isRequired })} {...rest} />

      {errors?.[name] && <FormError error={errors[name]} />}
    </>
  );
};

CheckboxField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  isRequired: PropTypes.bool
};

export default CheckboxField;
